import {cssTheme} from '@yandex-delivery/blocks'
import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

import {BannerImageType} from '../consts'

export const root = css`
  background-color: ${cssTheme.default.day.everWhite};
  border-radius: ${spacing(3)};
  padding: ${spacing(2)};
  position: relative;
  box-shadow: ${cssTheme.shadows.bottomNormal};
`
export const body = css`
  min-block-size: ${spacing(12.25)};
  padding-inline-end: ${spacing(15.5)};
  position: relative;
  z-index: 2;
`
export const title = css`
  padding-block-end: ${spacing(0.5)};
`
export const description = css`
  padding-inline-end: ${spacing(1.5)};
`
export const image = css`
  position: absolute;
  inset-block-start: 0;
  inset-inline-end: 0;
  z-index: 1;
`
export const imageMap: Record<BannerImageType, string> = {
  [BannerImageType.PaymentFromCurrentAccount]: css`
    inset-block-start: ${spacing(1)};
    inset-inline-end: ${spacing(-2)};
  `,
  [BannerImageType.TeamAccess]: css`
    inset-block-start: ${spacing(0.5)};
    inset-inline-end: ${spacing(-2)};
  `,
  [BannerImageType.WebCabinetAndYandexGo]: css`
    inset-block-start: ${spacing(0.5)};
    inset-inline-end: ${spacing(-2)};
  `,
  [BannerImageType.OrderDeliveriesInYandexGo]: css`
    inset-block-start: 0;
    inset-inline-end: 0;
  `,
  [BannerImageType.Sofa]: css`
    inset-inline-end: 0;
  `,
  [BannerImageType.Truck]: css`
    inset-inline-end: 0;
  `,
  [BannerImageType.Courier]: css`
    inset-block-start: ${spacing(-3)};
    inset-inline-end: ${spacing(-4)};
  `,
}
